
<ng-template #alert>
  <nz-alert
    nzCloseable
    [nzType]="type()" 
    [nzDescription]="description()"
    [nzMessage]="translateService.instant(message())">
  </nz-alert>
</ng-template>


